import axios from 'axios';
import apiConfig from '../api.config';

export default function checkinsStatsExportRequest(hotel, dateFrom, dateTo) {
  const {
    host,
    URIs: { checkinStatsExport },
  } = apiConfig;

  var filter = { dateFrom, dateTo };
  if (hotel) filter.hotel = hotel;

  const uri = `${host}${checkinStatsExport}?filter=${JSON.stringify(filter)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    })
    .then(res => {
      return res.data;
    });
}
